import React from 'lib/react';
import {
  EVPaper, EVGrid,
} from 'lib/components';
import SkeletonLoader from 'commonComponents/skeletonLoader';
import ManagePaymentOptionsStyles from './ManagePaymentOptionsStyles';

function ManagePaymentOptionsLoader() {
  const classes = ManagePaymentOptionsStyles();

  const skeleton1 = <SkeletonLoader height="27px" />;
  const skeleton2 = <SkeletonLoader height="24px" />;
  const skeleton3 = <SkeletonLoader height="44px" />;
  const skeleton4 = <SkeletonLoader className={classes.buttonSkeleton} />;
  const skeleton5 = <SkeletonLoader height="120px" />;
  const skeleton6 = <SkeletonLoader height="56px" />;
  const skeleton7 = <SkeletonLoader height="100px" />;
  const skeleton8 = <SkeletonLoader height="158px" />;

  return (
    <EVGrid className={classes.managePaymentContainer}>
      <EVGrid className={classes.prePaymentBox}>
        <EVPaper className={classes.sleletonBox}>
          {skeleton1}
          {skeleton2}
          {skeleton3}
          {skeleton4}
        </EVPaper>
        <EVPaper className={classes.sleletonBox}>
          {skeleton1}
          {skeleton3}
          {skeleton4}
        </EVPaper>
      </EVGrid>
      <EVPaper className={classes.membershipLevelContainer}>
        {skeleton1}
        {skeleton5}
        {skeleton6}
        {skeleton7}
        {skeleton8}
      </EVPaper>
    </EVGrid>
  );
}

export default ManagePaymentOptionsLoader;
